"use client";

import type { SubscriptionResponse } from "../hooks/use-subscription";

interface Props {
  subscription: SubscriptionResponse;
}

export function SubscriptionSummary({ subscription }: Props) {
  const {
    plan,
    status,
    billing_cadence,
    seat_count,
    current_period_end,
    cancel_at,
  } = subscription;

  const priceDisplay =
    billing_cadence === "annual"
      ? `$${((plan.price_annual_cents ?? 0) / 100).toFixed(0)}`
      : `$${((plan.price_monthly_cents ?? 0) / 100).toFixed(0)}`;

  return (
    <div className="rounded-lg border border-border bg-surface-elevated p-5">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-base font-medium text-heading">
            {plan.name} Plan
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            {priceDisplay}/seat/mo · {seat_count}{" "}
            {seat_count === 1 ? "seat" : "seats"} · Billed {billing_cadence}
          </p>
        </div>
        <span
          className={`text-xs font-medium px-2 py-0.5 rounded-full ${
            status === "active"
              ? "bg-green-500/10 text-green-400"
              : status === "canceling"
                ? "bg-amber-500/10 text-amber-400"
                : "bg-red-500/10 text-red-400"
          }`}
        >
          {status === "active"
            ? "Active"
            : status === "canceling"
              ? "Canceling"
              : status}
        </span>
      </div>

      {current_period_end && (
        <p className="text-xs text-muted-foreground mt-3">
          {cancel_at ? "Access until" : "Renews"}{" "}
          {new Date(current_period_end).toLocaleDateString()}
        </p>
      )}
    </div>
  );
}
